// extracted by mini-css-extract-plugin
export var details = "_ft-0";
export var inspectorPopover = "_ft-1";